import React from "react";
import { useSelector } from "react-redux";
import { SelectField, withNamespace } from "components/Form/FormikControls";

import { selectSpeciesAttributeOptionsBySpeciesId } from "selectors";
import { useResolveSpeciesId } from "hooks";
import { EMPTY_ARRAY } from "lib";

interface EIDExemptionReasonFieldProps {
  label?: string;
  name?: string;
  ns?: string;
  isClearable?: boolean;
  disabled?: boolean;
  tooltip?: string;
  menuPortalTarget?: HTMLElement;
  selectedSpeciesId?: number | null;
}
export function EIDExemptionReasonField(
  props: EIDExemptionReasonFieldProps,
): React.JSX.Element {
  const {
    ns,
    name = "exemption_id",
    label = "EID Exemption Reason",
    isClearable = false,
    disabled = false,
    tooltip = "Applicable exemption from meeting EID scanning requirements.",
    menuPortalTarget = undefined,
    selectedSpeciesId = null,
  } = props;

  const speciesId = useResolveSpeciesId(selectedSpeciesId);
  const speciesAttributeOptionsBySpeciesId = useSelector(
    selectSpeciesAttributeOptionsBySpeciesId,
  );

  const exemptions =
    speciesAttributeOptionsBySpeciesId[speciesId]?.exemptions || EMPTY_ARRAY;

  return (
    <SelectField
      label={label}
      name={withNamespace(ns, name)}
      options={exemptions}
      isClearable={isClearable}
      disabled={disabled}
      tooltip={tooltip}
      menuPortalTarget={menuPortalTarget || document.body}
    />
  );
}
